import React, { MutableRefObject } from 'react'

import cx from 'classnames'

import styles from './styles.module.css'

interface Props {
  children: React.ReactNode
  containerRef?: MutableRefObject<any>
  color: 'light' | 'dark'
  className?: string
  'data-ocweb-id'?: string
}

export const DriftScrollbars: React.FC<Props> = ({
  children,
  containerRef,
  color,
  className,
  'data-ocweb-id': dataTestId,
}) => {
  return (
    <div className={styles.scrollbarWrapper}>
      <div
        data-ocweb-id={dataTestId}
        ref={containerRef}
        className={cx(className, styles.scrollbar, {
          [styles.dark]: color === 'dark',
          [styles.light]: color === 'light',
        })}>
        {children}
      </div>
    </div>
  )
}
